export default {
  path: '',
  component: () => import('@/layouts/full-page/FullPage.vue'),
  children: [
    {
      path: '/toklog/:token',
      name: 'token-login',
      component: () => import('@/views/pages/TokenLogin.vue'),
      meta: { title: 'Signing in' },
    },
  ],
};
